{
    "la Massana": "La Massana",
    "Herāt": "Herat",
    "San Ramón de la Nueva Orán": "Orán",
    "San Fernando del Valle de Catamarca": "Catamarca",
    "Tafí del Valle": "Tafi del Valle",
    "Jesús María": "Jesus Maria",
    "Tío Pujio": "Tio Pujio",
    "Mörbisch am See": "Moerbisch am See",
    "Bad Bleiberg": "Bleiberg ob Villach",
    "Gmünd in Kärnten": "Gmünd",
    "Sankt Kanzian am Klopeiner See": "Sankt Kanzian",
    "St. Urban": "Sankt Urban",
    "St. Veit an der Glan": "Sankt Veit an der Glan",
    "Baden": "Baden bei Wien",
    "Krems an der Donau": "Krems",
    "Neukirchen am Großvenediger": "Neukirchen am Grossvenediger",
    "Leibnitz": "Leibnitz, Styria",
    "Sölden": "Solden",
    "Logan": "Logan City",
    "Mount Coolum": "Mt Coolum",
    "Noosa Heads": "Noosa",
    "Moe": "Yallourn",
    "Bakıxanov": "Bakikhanov",
    "Sumqayıt": "Sumqayit",
    "Antwerpen": "Antwerp",
    "Gent": "Ghent",
    "Amblève": "Amel",
    "Bullange": "Büllingen",
    "Saint-Vith": "Sankt Vith",
    "Ruse": "Rousse",
    "Santa Cruz de la Sierra": "Santa Cruz",
    "Nova Olinda do Norte": "Nova Olinda Do Norte",
    "Serra do Ramalho": "Serra Do Ramalho",
    "Tabocas do Brejo Velho": "Tabocas Do Brejo Velho",
    "Belágua": "BelÁgua",
    "Comodoro": "Comodoro Municipality",
    "Feliz Natal": "Feliz Natal Municipality",
    "Paranatinga": "Paranatinga Municipality",
    "Ponta de Pedras": "Ponta De Pedras",
    "Porto de Moz": "Porto De Moz",
    "Santa Maria das Barreiras": "Santa Maria Das Barreiras",
    "Santana do Araguaia": "Santana Do Araguaia",
    "Alta Floresta d'Oeste": "Alta Floresta D'Oeste",
    "Machadinho d'Oeste": "Machadinho D'Oeste",
    "Caroebe": "Caroebe Municipality",
    "Normandia": "Normandia Municipality",
    "Bandeirantes do Tocantins": "Bandeirantes Do Tocantins",
    "Pau d'Arco": "Pau D'Arco",
    "Asbestos": "Val-des-Sources",
    "La Pocatière": "Ste. Anne de la Pocatière",
    "Lac-Mégantic": "Lac-Megantic",
    "Mont-Saint-Grégoire": "Mont-Saint-Gregoire",
    "Montmagny": "Saint Thomas de Montmagny",
    "Montréal": "Montreal",
    "Sacré-Coeur": "Sacre-Coeur",
    "Saint-Césaire": "Saint-Cesaire",
    "Saint-Félicien": "Saint-Felicien",
    "Saint-Félix-de-Valois": "Saint-Felix-de-Valois",
    "Saint-Hippolyte": "St-Hippolyte",
    "Saint-Jérôme": "Saint-Jerome",
    "Saint-Marc-des-Carrières": "Saint-Marc-des-Carrieres",
    "Saint-Mathieu": "Saint-Mathieu-de-Rioux",
    "Saint-Siméon": "Saint-Simeon",
    "Saint-Édouard": "Saint-Edouard",
    "Sainte-Adèle": "Sainte-Adele",
    "Sainte-Béatrix": "Sainte-Beatrix",
    "Sainte-Élisabeth": "Sainte-Elisabeth",
    "Sept-Îles": "Sept-Iles",
    "Vallée-Jonction": "Vallee-Jonction",
    "Venise-en-Québec": "Venise-en-Quebec",
    "Oberegg": "Oberegg District",
    "Teufen": "Teufen AR",
    "Sankt Antoni": "St. Antoni",
    "Genève": "Geneva",
    "Luzern": "Lucerne",
    "Sankt Niklaus": "St. Niklaus",
    "Sitten": "Sion",
    "Zürich": "Zurich",
    "Los Álamos": "Los Alamos",
    "Puerto Montt": "Port Montt",
    "Río Negro": "Rio Negro",
    "Jiayuguan": "Jiayuguan City",
    "Jilin": "Jilin City",
    "ChangZhou": "Changzhou",
    "NanJing": "Nanjing",
    "NanTong": "Nantong",
    "SuQian": "Suqian",
    "SuZhou": "Suzhou",
    "TaiZhou": "Taizhou",
    "WuXi": "Wuxi",
    "XuZhou": "Xuzhou",
    "YanCheng": "Yancheng",
    "YangZhou": "Yangzhou",
    "ZhenJiang": "Zhenjiang",
    "Hami": "Kumul",
    "Cartagena de Indias": "Cartagena",
    "San Andrés de Sotavento": "San Andres de Sotavento",
    "Girardot": "Girardot City",
    "Bogotá D.C.": "Bogota D.C.",
    "San Agustín": "San Agustin",
    "Pijiño del Carmen": "Pijino del Carmen",
    "Castilla la Nueva": "Castilla La Nueva",
    "San Martín": "San Martin",
    "El Carmen de Chucurí": "El Carmen de Chucuri",
    "San Luis de Sincé": "San Luis de Since",
    "Santiago de Tolú": "Tolú",
    "San Sebastián de Mariquita": "Mariquita",
    "Cali": "Santiago de Cali",
    "Brandenburg an der Havel": "Brandenburg",
    "Calau": "Kalawa",
    "Dallgow-Döberitz": "Dallgow-Doeberitz",
    "Königs Wusterhausen": "Koenigs Wusterhausen",
    "Lübben": "Lubin",
    "Lübbenau": "Lubnjow",
    "Abtsgmünd": "Abtsgmuend",
    "Bad Dürrheim": "Bad Durrheim",
    "Bad Säckingen": "Bad Sackingen",
    "Bad Überkingen": "Bad Uberkingen",
    "Biberach": "Biberach an der Riss",
    "Biberach an der Riß": "Biberach an der Riss",
    "Blaubeuren": "Blaubeuren Abbey",
    "Bollschweil": "Bollschweil Priory",
    "Breisach am Rhein": "Breisach",
    "Böbingen an der Rems": "Bobingen an der Rems",
    "Esslingen": "Esslingen am Neckar",
    "Freiburg": "Freiburg im Breisgau",
    "Furtwangen": "Furtwangen im Schwarzwald",
    "Heidenheim an der Brenz": "Heidenheim",
    "Herdwangen-Schönach": "Herdwangen-Schonach",
    "Königsbach-Stein": "Konigsbach-Stein",
    "Königsfeld im Schwarzwald": "Konigsfeld im Schwarzwald",
    "Lauda-Königshofen": "Lauda-Konigshofen",
    "Lörrach": "Loerrach",
    "Meßkirch": "Messkirch",
    "Mühlhausen-Ehingen": "Muhlhausen-Ehingen",
    "Niefern-Öschelbronn": "Niefern-Oschelbronn",
    "Sankt Blasien": "Saint Blasien",
    "Sankt Johann": "St. Johann",
    "Uhldingen-Mühlhofen": "Uhldingen-Muhlhofen",
    "Weil im Schönbuch": "Weil im Schonbuch",
    "Ölbronn-Dürrn": "OElbronn-Duerrn",
    "Ühlingen-Birkendorf": "Uhlingen-Birkendorf",
    "Altdorf": "Altdorf bei Nuernberg",
    "Asbach-Bäumenheim": "Asbach-Baumenheim",
    "Bad Brückenau": "Bad Bruckenau",
    "Bad Füssing": "Bad Fussing",
    "Bad Tölz": "Bad Toelz",
    "Bad Wörishofen": "Bad Worishofen",
    "Dießen am Ammersee": "Diessen am Ammersee",
    "Garching bei München": "Garching",
    "Höchstädt an der Donau": "Hochstadt an der Donau",
    "Höhenkirchen-Siegertsbrunn": "Hohenkirchen-Siegertsbrunn",
    "Lohr am Main": "Lohr a. Main",
    "Maxhütte-Haidhof": "Maxhutte-Haidhof",
    "Nürnberg": "Nuremberg",
    "Rothenburg ob der Tauber": "Rothenburg upon Tauber",
    "Röthenbach an der Pegnitz": "Rothenbach an der Pegnitz",
    "Straßlach-Dingharting": "Strasslach-Dingharting",
    "Töging am Inn": "Toging am Inn",
    "Unterschleißheim": "Unterschleissheim",
    "Wörth am Main": "Worth am Main",
    "Wörth an der Donau": "Worth an der Donau",
    "Alsbach-Hähnlein": "Alsbach-Hahnlein",
    "Bad Homburg vor der Höhe": "Bad Homburg",
    "Bad König": "Bad Koenig",
    "Bad Soden-Salmünster": "Bad Soden-Salmuenster",
    "Gießen": "Giessen",
    "Groß-Bieberau": "Gross-Bieberau",
    "Groß-Gerau": "Gross-Gerau",
    "Groß-Rohrheim": "Gross-Rohrheim",
    "Groß-Zimmern": "Gross-Zimmern",
    "Höchst im Odenwald": "Hoechst im Odenwald",
    "Königstein im Taunus": "Koenigstein im Taunus",
    "Mörfelden-Walldorf": "Moerfelden-Walldorf",
    "Ober-Mörlen": "Ober-Morlen",
    "Rosbach vor der Höhe": "Rosbach vor der Hoehe",
    "Rüdesheim am Rhein": "Ruedesheim am Rhein",
    "Steinau an der Straße": "Steinau an der Strasse",
    "Mühl Rosin": "Muehl Rosin",
    "Ostseebad Kühlungsborn": "Ostseebad Kuehlungsborn",
    "Groß Twülpstedt": "Gross Twulpstedt",
    "Hameln": "Hamelin",
    "Hannover": "Hanover",
    "Königslutter am Elm": "Koenigslutter am Elm",
    "Neustadt am Rübenberge": "Neustadt am Ruebenberge",
    "Nörten-Hardenberg": "Noerten-Hardenberg",
    "Verden": "Verden an der Aller",
    "Bad Münstereifel": "Bad Muenstereifel",
    "Geldern": "Guelders",
    "Ibbenbüren": "Ibbenbueren",
    "Köln": "Cologne",
    "Preußisch Oldendorf": "Preussisch Oldendorf",
    "Rheda-Wiedenbrück": "Rheda-Wiedenbrueck",
    "Wülfrath": "Wuelfrath",
    "Übach-Palenberg": "UEbach-Palenberg",
    "Bad Dürkheim": "Bad Duerkheim",
    "Bad Hönningen": "Bad Hoenningen",
    "Bruchmühlbach-Miesau": "Bruchmuhlbach-Miesau",
    "Böhl-Iggelheim": "Bohl-Iggelheim",
    "Dittelsheim-Heßloch": "Dittelsheim-Hessloch",
    "Glan-Münchweiler": "Glan-Munchweiler",
    "Hoppstädten-Weiersbach": "Hoppstadten-Weiersbach",
    "Höhr-Grenzhausen": "Hoehr-Grenzhausen",
    "Kirchheim an der Weinstraße": "Kirchheim an der Weinstrasse",
    "Landau in der Pfalz": "Landau",
    "Mülheim-Kärlich": "Muelheim-Kaerlich",
    "Münster-Sarmsheim": "Muenster-Sarmsheim",
    "Rieschweiler-Mühlbach": "Rieschweiler-Muehlbach",
    "Rödersheim-Gronau": "Rodersheim-Gronau",
    "Sankt Goarshausen": "Saint Goarshausen",
    "Schönenberg-Kübelberg": "Schoenenberg-Kuebelberg",
    "Thaleischweiler-Fröschen": "Thaleischweiler-Froschen",
    "Wörth am Rhein": "Woerth am Rhein",
    "Brande-Hörnerkirchen": "Brande-Hornerkirchen",
    "Büdelsdorf": "Buedelsdorf",
    "Elsdorf-Westermühlen": "Elsdorf-Westermuhlen",
    "Henstedt-Ulzburg": "Henstedt-Ulzburg Municipality",
    "Klein Rönnau": "Klein Roennau",
    "Kröppelshagen-Fahrendorf": "Kroeppelshagen-Fahrendorf",
    "Kölln-Reisiek": "Kolln-Reisiek",
    "Sankt Michaelisdonn": "Saint Michaelisdonn",
    "Wyk auf Föhr": "Wyk auf Foehr",
    "Bad Düben": "Bad Dueben",
    "Großpostwitz": "Budestecy",
    "Neukirch": "Neukirch/Lausitz",
    "Reichenbach": "Reichenbach/Vogtland",
    "Sankt Egidien": "Saint Egidien",
    "Wilkau-Haßlau": "Wilkau-Hasslau",
    "Bad Dürrenberg": "Bad Duerrenberg",
    "Bad Lauchstädt": "Bad Lauchstaedt",
    "Bad Köstritz": "Bad Koestritz",
    "Tadjourah": "Tadjoura",
    "Grenaa": "Grenå",
    "Struer": "Struer Municipality",
    "Århus": "Aarhus",
    "Vejen": "Vejen Municipality",
    "Vejen Kommune": "Vejen Municipality",
    "Allerød Kommune": "Allerød Municipality",
    "Ballerup": "Ballerup Municipality",
    "Ballerup Kommune": "Ballerup Municipality",
    "Frederiksberg Kommune": "Frederiksberg",
    "Gentofte Kommune": "Gentofte Municipality",
    "Glostrup Kommune": "Glostrup Municipality",
    "Helsingør": "Elsinore",
    "Rødovre": "Rødovre Municipality",
    "Rødovre Kommune": "Rødovre Municipality",
    "Higüey": "Salvaleón de Higüey",
    "Concepción de La Vega": "Concepción de la Vega",
    "Batna": "Batna City",
    "Tamanrasset": "Tamanghasset",
    "Sidi Bel Abbès": "Sidi Bel Abbes",
    "Sevilla": "Seville",
    "Zahara": "Zahara de los Atunes",
    "Castejón de Sos": "Castejon de Sos",
    "Castro-Urdiales": "Castro Urdiales",
    "Sigüenza": "Siguenza",
    "San Sebastián de la Gomera": "San Sebastián de La Gomera",
    "Santa Cruz de la Palma": "Santa Cruz de La Palma",
    "Barberà del Vallès": "Barbera Del Valles",
    "El Masnou": "el Masnou",
    "El Prat de Llobregat": "el Prat de Llobregat",
    "Roda de Barà": "Roda de Berà",
    "Sant Carles de la Ràpita": "Sant Carles de la Rapita",
    "Santa Cristina d'Aro": "Santa Cristina de Aro",
    "Vallbona": "Vallbona d'Anoia",
    "Vielha": "Vielha e Mijaran",
    "la Bisbal d'Empordà": "La Bisbal",
    "Jaraíz de la Vera": "Jaraiz de la Vera",
    "As Pontes de García Rodríguez": "As Pontes de Garcia Rodriguez",
    "Puente Nuevo": "A Pontenova",
    "Chamartín": "Chamartin",
    "Peralta": "Peralta – Azkoien",
    "Donostia / San Sebastián": "Donostia / San Sebastian",
    "Alfarp": "Alfarb",
    "Benifairó de les Valls": "Benifairo de les Valls",
    "Calp": "Calpe",
    "Crevillente": "Crevillent",
    "Hondón de las Nieves": "Hondon de las Nieves",
    "Hondón de los Frailes": "Hondon de los Frailes",
    "Jijona": "Xixona",
    "Monserrat": "Montserrat",
    "Monóvar": "Monòver",
    "Palma de Gandía": "Palma de Gandia",
    "Peníscola": "Peñíscola",
    "Real de Gandía": "Real de Gandia",
    "Ráfol de Salem": "Rafol de Salem",
    "San Juan de Alicante": "Sant Joan d'Alacant",
    "San Miguel de Salinas": "San Miguel",
    "Villanueva de Castellón": "Villanueva de Castellon",
    "Gondar": "Gonder",
    "Arpajon-sur-Cère": "Arpajon-sur-Cere",
    "Auberives-sur-Varèze": "Auberives-sur-Vareze",
    "Buxières-les-Mines": "Buxieres-les-Mines",
    "Chamonix-Mont-Blanc": "Chamonix",
    "Charbonnières-les-Varennes": "Charbonnieres-les-Varennes",
    "Châtel-Guyon": "Chatel-Guyon",
    "Cournon-d’Auvergne": "Cournon-d'Auvergne",
    "Pouilly-lès-Feurs": "Pouilly-les-Feurs",
    "Riom-ès-Montagnes": "Riom-es-Montagnes",
    "Saint-Just-d'Ardèche": "Saint-Just-d'Ardeche",
    "Saint-Martin-d’Hères": "Saint-Martin-d'Hères",
    "Saint-Pierre-de-Bœuf": "Saint-Pierre-de-Boeuf",
    "Saint-Égrève": "Saint Egreve",
    "Saint-Étienne": "Saint-Etienne",
    "Saint-Étienne-du-Bois": "Saint-Etienne-du-Bois",
    "Sainte-Sigolène": "Sainte-Sigolene",
    "Saint-Benin-d’Azy": "Saint-Benin-dAzy",
    "Argentré-du-Plessis": "Argentre-du-Plessis",
    "Bréal-sous-Montfort": "Breal-sous-Montfort",
    "Chasné-sur-Illet": "Chasne-sur-Illet",
    "Châteauneuf-du-Faou": "Chateauneuf-du-Faou",
    "Châtillon-en-Vendelais": "Chatillon-en-Vendelais",
    "Clohars-Carnoët": "Clohars-Carnoet",
    "Ercé-en-Lamée": "Erce-en-Lamee",
    "Ercé-près-Liffré": "Erce-pres-Liffre",
    "Ergué-Gabéric": "Ergue-Gaberic",
    "Hédé-Bazouges": "Hede-Bazouges",
    "Hôpital-Camfrout": "Hopital-Camfrout",
    "La Bouëxière": "La Bouexiere",
    "La Forêt-Fouesnant": "La Foret-Fouesnant",
    "La Gouesnière": "La Gouesniere",
    "La Méaugon": "La Meaugon",
    "La Mézière": "La Meziere",
    "Le Bono": "Bono",
    "Le Faouët": "Le Faouet",
    "Le Folgoët": "Le Folgoet",
    "Le Trévoux": "Le Trevoux",
    "Livré-sur-Changeon": "Livre-sur-Changeon",
    "Louvigné-de-Bais": "Louvigne-de-Bais",
    "Louvigné-du-Désert": "Louvigne-du-Desert",
    "Martigné-Ferchaud": "Martigne-Ferchaud",
    "Maël-Carhaix": "Mael-Carhaix",
    "Montreuil-sous-Pérouse": "Montreuil-sous-Perouse",
    "Moëlan-sur-Mer": "Moelan-sur-Mer",
    "Mûr-de-Bretagne": "Mur-de-Bretagne",
    "Pleine-Fougères": "Pleine-Fougeres",
    "Plestin-les-Grèves": "Plestin-les-Greves",
    "Plonévez-Porzay": "Plonevez-Porzay",
    "Plonévez-du-Faou": "Plonevez-du-Faou",
    "Plounéour-Ménez": "Plouneour-Menez",
    "Plounéour-Trez": "Plouneour-Trez",
    "Plounévez-Lochrist": "Plounevez-Lochrist",
    "Plounévez-Moëdec": "Plounevez-Moedec",
    "Plounévez-Quintin": "Plounevez-Quintin",
    "Plouër-sur-Rance": "Plouer-sur-Rance",
    "Plélan-le-Grand": "Plelan-le-Grand",
    "Plélan-le-Petit": "Plelan-le-Petit",
    "Pléneuf-Val-André": "Pleneuf-Val-Andre",
    "Plénée-Jugon": "Plenee-Jugon",
    "Pont-l’Abbé": "Pont-l'Abbé",
    "Priziac": "Priziac ( Priziac )",
    "Saint-Avé": "Saint-Ave",
    "Saint-Barnabé": "Saint-Barnabe",
    "Saint-Brice-en-Coglès": "Saint-Brice-en-Cogles",
    "Saint-Germain-en-Coglès": "Saint-Germain-en-Cogles",
    "Saint-Grégoire": "Saint-Gregoire",
    "Saint-Hélen": "Saint-Helen",
    "Saint-Jean-Brévelay": "Saint-Jean-Brevelay",
    "Saint-Jouan-des-Guérets": "Saint-Jouan-des-Guerets",
    "Saint-Malo": "St-Malo",
    "Saint-Médard-sur-Ille": "Saint-Medard-sur-Ille",
    "Saint-Méen-le-Grand": "Saint-Meen-le-Grand",
    "Saint-Méloir-des-Ondes": "Saint-Meloir-des-Ondes",
    "Saint-Nicolas-du-Pélem": "Saint-Nicolas-du-Pelem",
    "Saint-Sulpice-la-Forêt": "Saint-Sulpice-la-Foret",
    "Saint-Thégonnec": "Saint-Thegonnec",
    "Saint-Étienne-en-Coglès": "Saint-Etienne-en-Cogles",
    "Saint-Évarzec": "Saint-Evarzec",
    "Sainte-Hélène": "Sainte-Helene",
    "Château-Renault": "Chateau-Renault",
    "Châteauneuf-sur-Loire": "Chateauneuf-sur-Loire",
    "Ay": "Aÿ",
    "Châlons-en-Champagne": "Chalons-en-Champagne",
    "Flize": "Élan",
    "Saint-Dié-des-Vosges": "Saint-Dié",
    "Condé-sur-l’Escaut": "Conde-sur-l'Escaut",
    "Dunkerque": "Dunkirk",
    "Marcq-en-Barœul": "Marcq-en-Baroeul",
    "Mons-en-Barœul": "Mons-en-Baroeul",
    "Montreuil": "Montreuil-sur-Mer",
    "Saint-Cyr-l’École": "Saint-Cyr-l'École",
    "Saint-Ouen-l’Aumône": "Saint-Ouen-l'Aumone",
    "Ambarès-et-Lagrave": "Ambares-et-Lagrave",
    "Argenton-les-Vallées": "Argenton-les-Vallees",
    "Ars-en-Ré": "Ars-en-Re",
    "Lathus-Saint-Rémy": "Lathus-Saint-Remy",
    "Le Mas-d’Agenais": "Le Mas-d'Agenais",
    "Mauléon-Licharre": "Mauleon-Licharre",
    "Mazères-Lezons": "Mazeres-Lezons",
    "Saint-Pierre-d’Oléron": "Saint-Pierre-d'Oleron",
    "Saint-Pée-sur-Nivelle": "Saint-Pee-sur-Nivelle",
    "Sauveterre-de-Béarn": "Sauveterre-de-Bearn",
    "Soorts-Hossegor": "Soorts",
    "Pîtres": "Pitres",
    "Argelès-Gazost": "Argeles-Gazost",
    "Baziège": "Baziege",
    "Elne": "Elna",
    "Ferrals-les-Corbières": "Ferrals-les-Corbieres",
    "Ille-sur-Têt": "Ille-sur-Tet",
    "Saint-Estève": "Saint-Esteve",
    "Saint-Geniès-de-Malgoirès": "Saint-Genies-de-Malgoires",
    "Saint-Génis-des-Fontaines": "Saint-Genis-des-Fontaines",
    "Saint-Juéry": "Saint-Juery",
    "Thézan-lès-Béziers": "Thezan-les-Beziers",
    "Trie-sur-Baïse": "Trie-sur-Baise",
    "Villeneuve-lès-Maguelone": "Villeneuve-les-Maguelone",
    "Châteauneuf-les-Martigues": "Chateauneuf-les-Martigues",
    "La Farlède": "La Farlede",
    "L’Isle-sur-la-Sorgue": "L'Isle-sur-la-Sorgue",
    "Oppède le Vieux": "Oppede le Vieux",
    "Ambrières-les-Vallées": "Ambrieres-les-Vallees",
    "Bois-de-Cené": "Bois-de-Cene",
    "Château-Gontier": "Chateau-Gontier",
    "Guémené-Penfao": "Guemene-Penfao",
    "La Bernardière": "La Bernardiere",
    "La Bruffière": "La Bruffiere",
    "La Chevrolière": "La Chevroliere",
    "La Haie-Fouassière": "La Haie-Fouassiere",
    "La Limouzinière": "La Limouziniere",
    "La Ménitré": "La Menitre",
    "La Regrippière": "La Regrippiere",
    "La Remaudière": "La Remaudiere",
    "Le Gâvre": "Le Gavre",
    "Les Sables-d’Olonne": "Les Sables-d'Olonne",
    "Les Sorinières": "Les Sorinieres",
    "Maisdon-sur-Sèvre": "Maisdon-sur-Sevre",
    "Moisdon-la-Rivière": "Moisdon-la-Riviere",
    "Mûrs-Erigné": "Murs-Erigne",
    "Noirmoutier-en-l’Île": "Noirmoutier-en-l'Ile",
    "Port-Saint-Père": "Port-Saint-Pere",
    "Saint-André-des-Eaux": "Saint-Andre-des-Eaux",
    "Saint-Aubin-des-Châteaux": "Saint-Aubin-des-Chateaux",
    "Saint-Hilaire-de-Chaléons": "Saint-Hilaire-de-Chaleons",
    "Saint-Mars-du-Désert": "Saint-Mars-du-Desert",
    "Saint-Ouën-des-Toits": "Saint-Ouen-des-Toits",
    "Saint-Père-en-Retz": "Saint-Pere-en-Retz",
    "Saint-Étienne-de-Mer-Morte": "Saint-Etienne-de-Mer-Morte",
    "Saint-Étienne-de-Montluc": "Saint-Etienne-de-Montluc",
    "Sargé-lès-le-Mans": "Sarge-les-le-Mans",
    "Thouaré-sur-Loire": "Thouare-sur-Loire",
    "Étival-lès-le-Mans": "Etival-les-le-Mans",
    "Kingston upon Hull": "Hull",
    "St. Helens": "St Helens",
    "Isle Of Mull": "Isle of Mull",
    "Orkney": "Orkney Islands",
    "Saint Andrews": "St Andrews",
    "Bridgend county borough": "Bridgend",
    "Pontyclun": "Pont-y-clun",
    "Serekunda": "Serrekunda",
    "Añisoc": "Añisok",
    "Efkarpía": "Efkarpia",
    "Kilkís": "Kilkis",
    "Nigríta": "Nigrita",
    "Néa Moudhaniá": "Nea Moudania",
    "Néa Róda": "Nea Roda",
    "Pefkochóri": "Pefkochori",
    "Péfka": "Pefka",
    "Édessa": "Edessa",
    "Amýntaio": "Amyntaio",
    "Amárynthos": "Amarynthos",
    "Drapetsóna": "Drapetsona",
    "Ekáli": "Ekali",
    "Kallithéa": "Kallithea",
    "Keratéa": "Keratea",
    "Néa Chalkidóna": "Nea Chalkidona",
    "Néa Mákri": "Nea Makri",
    "Néo Psychikó": "Neo Psychiko",
    "Pallíni": "Pallini",
    "Thrakomakedónes": "Thrakomakedones",
    "Copán Ruinas": "Copán",
    "Puerto Cortés": "Puerto Cortez",
    "dunaújváros": "Dunaújváros",
    "Ambon": "Ambon City",
    "Cahir": "Caher",
    "Carrigtwohill": "Carrigtohill",
    "Rathcormac": "Rathcormack",
    "Ramelton": "Rathmelton",
    "Sederot": "Sderot",
    "Atlit": "Athlit",
    "Abū Ghaush": "Abu Ghosh",
    "Panaji": "Panjim",
    "Gurgaon": "Gurugram",
    "Daltonganj": "Medininagar",
    "Hazaribag": "Hazaribagh",
    "Mangaluru": "Mangalore",
    "Mysuru": "Mysore",
    "Sulya": "Sullia",
    "Dombivli": "Dombivali",
    "Kapurthala": "Kapurthala Town",
    "Velur": "Vellore",
    "Allahabad": "Prayagraj",
    "Zaxo": "Zakho",
    "Garðabær": "Garðabaer",
    "Hafnarfjörður": "Hafnarfjordur",
    "Kópavogur": "Kopavogur",
    "Reykjavík": "Reykjavik",
    "Grindavík": "Grindavik",
    "Keflavík": "Keflavik",
    "Ísafjörður": "Isafjordur",
    "Sauðárkrókur": "Sauðarkrokur",
    "Dalvík": "Dalvik",
    "Húsavík": "Norðurþing",
    "Hveragerði": "Hveragerdi",
    "Castelletto Sopra Ticino": "Castelletto sopra Ticino",
    "Fontaneto D'Agogna": "Fontaneto d'Agogna",
    "Riva Presso Chieri": "Riva presso Chieri",
    "San Maurizio D'Opaglio": "San Maurizio d'Opaglio",
    "Vaprio D'Agogna": "Vaprio d'Agogna",
    "Boffalora Sopra Ticino": "Boffalora sopra Ticino",
    "Cavaria Con Premezzo": "Cavaria con Premezzo",
    "Robecchetto Con Induno": "Robecchetto con Induno",
    "Vertemate Con Minoprio": "Vertemate con Minoprio",
    "Avelengo": "Hafling",
    "Bressanone": "Brixen",
    "Brunico": "Bruneck",
    "Campo Tures": "Sand in Taufers",
    "Campo di Trens": "Freienfeld",
    "Castelrotto": "Kastelruth",
    "Cermes": "Tscherms",
    "Chienes": "Kiens",
    "Chiusa": "Klausen",
    "Corvara in Badia": "Corvara",
    "Dobbiaco": "Toblach",
    "Egna": "Neumarkt",
    "Falzes": "Pfalzen",
    "Gargazzone": "Gargazon",
    "Glorenza": "Glurns",
    "Laces": "Latsch",
    "Lagundo": "Algund",
    "Laion": "Lajen",
    "Lasa": "Laas",
    "Malles Venosta": "Mals",
    "Malè": "Malé",
    "Marlengo": "Marling",
    "Meltina": "Mölten",
    "Montagna": "Montan",
    "Moso in Passiria": "Moos in Passeier",
    "Nago-Torbole": "Nago–Torbole",
    "Nalles": "Nals",
    "Naturno": "Naturns",
    "Nova Levante": "Welschnofen",
    "Nova Ponente": "Deutschnofen",
    "Ora": "Auer",
    "Ortisei": "Urtijëi",
    "Parcines": "Partschins",
    "Perca": "Percha",
    "Ponte Gardena": "Waidbruck",
    "Postal": "Burgstall",
    "Prato Allo Stelvio": "Prad am Stilfser Joch",
    "Racines": "Ratschings",
    "Rio di Pusteria": "Mühlbach",
    "San Candido": "Innichen",
    "San Genesio Atesino": "Jenesien",
    "San Leonardo in Passiria": "St. Leonhard in Passeier",
    "San Lorenzo di Sebato": "St. Lorenzen",
    "San Michele All'Adige": "San Michele all'Adige",
    "Sarentino": "Sarnthein",
    "Scena": "Schenna",
    "Sesto": "Sexten",
    "Silandro": "Schlanders",
    "Sluderno": "Schluderns",
    "Terento": "Terenten",
    "Terlano": "Terlan",
    "Tesimo": "Tisens",
    "Tires": "Tiers",
    "Tubre": "Taufers im Münstertal",
    "Varna": "Vahrn",
    "Velturno": "Feldthurns",
    "Villabassa": "Niederdorf",
    "Vipiteno": "Sterzing",
    "Ronco All'Adige": "Ronco all'Adige",
    "Castelnovo ne'Monti": "Castelnovo ne' Monti",
    "Lesignano de'Bagni": "Lesignano de' Bagni",
    "Varano De' Melegari": "Varano de' Melegari",
    "Poggio A Caiano": "Poggio a Caiano",
    "Jesi": "Iesi",
    "Anguillara Sabazia": "Anguillara",
    "Isola del Gran Sasso d'Italia": "Isola del Gran Sasso",
    "L'Aquila": "L’Aquila",
    "Magliano De'Marsi": "Magliano de' Marsi",
    "Caiazzo": "Caiatia",
    "San Giovanni A Piro": "San Giovanni a Piro",
    "Sant'Agata de'Goti": "Sant'Agata de' Goti",
    "Sant'Angelo A Scala": "Sant'Angelo a Scala",
    "Santa Maria A Vico": "Santa Maria a Vico",
    "Torre le Nocelle": "Torre Le Nocelle",
    "Castrignano De' Greci": "Castrignano de' Greci",
    "San Vito Sullo Ionio": "San Vito sullo Ionio",
    "Siracusa": "Syracuse",
    "Onanì": "Onani",
    "Sant'Antioco": "SantAntioco",
    "Trinità d'Agultu e Vignola": "Trinita d'Agultu",
    "Noda-shi": "Noda",
    "Kōfu": "Kofu",
    "Ōmuta": "Omuta",
    "Sen Monorom": "Sen Moronom",
    "Seosan": "Seosan City",
    "Zahlé": "Zahle",
    "Kirchberg": "Luxembourg-Kirchberg",
    "Al-Hoceima": "Al Hoceima",
    "Djénné": "Djenné",
    "Uliastay": "Uliastai",
    "Zouerate": "Zouérat",
    "Rincón de Romos": "Rincon de Romos",
    "Licenciado Gustavo Díaz Ordaz": "Licenciado Gustavo Diaz Ordaz",
    "Lázaro Cárdenas": "Lazaro Cardenas",
    "Chihuahua": "Chihuahua City",
    "Octaviano López": "López",
    "Congregación Reforma": "Congregacion Reforma",
    "Nuevo León": "Nuevo Leon",
    "Palenque": "Palenque/Temp",
    "Ciudad Melchor Múzquiz": "Ciudad Melchor Muzquiz",
    "Minas de Barroterán": "Minas de Barroteran",
    "Sierra Mojada": "Sierra Mojada Municipality",
    "General Lázaro Cárdenas": "General Lazaro Cardenas",
    "Victoria de Durango": "Durango",
    "Chilapa de Álvarez": "Chilapa de Alvarez",
    "Técpan de Galeana": "Tecpan de Galeana",
    "Zirándaro de los Chávez": "Zirandaro de los Chavez",
    "Guanajuato": "Guanajuato City",
    "Purísima de Bustos": "Purisima de Bustos",
    "San José de Llanos": "San Jose de Llanos",
    "Santa Cruz de Juventino Rosas": "Juventino Rosas",
    "Tierra Fría": "Tierra Fria",
    "Pachuca de Soto": "Pachuca",
    "San Felipe Orizatlán": "San Felipe Orizatlan",
    "Tezontepec": "Tezontepec de Aldama",
    "Tulancingo de Bravo": "Tulancingo",
    "Cabo Corrientes": "Cabo Corrientes Municipality",
    "La Manzanilla de La Paz": "La Manzanilla de la Paz",
    "San Diego de Alejandría": "San Diego de Alejandria",
    "San Martín de Bolaños": "San Martin de Bolanos",
    "San Sebastián del Oeste": "San Sebastian del Oeste",
    "Valle de Juárez": "Valle de Juarez",
    "Ecatepec de Morelos": "Ecatepec",
    "Huixquilucan": "Huixquilucan de Degollado",
    "Naucalpan de Juárez": "Naucalpan",
    "Polotitlán": "Polotitlan de la Ilustracion",
    "San José Villa de Allende": "San Jose Villa de Allende",
    "San José del Rincón Centro": "San Jose del Rincon Centro",
    "Santa Cruz Atizapán": "Santa Cruz Atizapan",
    "Temascaltepec": "Temascaltepec de Gonzalez",
    "Teotihuacán de Arista": "Teotihuacán",
    "Acuítzio del Canje": "Acuitzio del Canje",
    "Heróica Zitácuaro": "Heroica Zitacuaro",
    "Jiquílpan de Juárez": "Jiquilpan de Juarez",
    "Jungapeo de Juárez": "Jungapeo de Juarez",
    "Maravatío de Ocampo": "Maravatio de Ocampo",
    "Santa Fé de la Laguna": "Santa Fe",
    "Tangancícuaro": "Tangancicuaro de Arista",
    "Álvaro Obregón": "Alvaro Obregon",
    "La Peñita de Jaltomba": "La Penita de Jaltomba",
    "Ciudad Apodaca": "Apodaca",
    "Ciudad Benito Juárez": "Ciudad Benito Juarez",
    "Ciudad General Escobedo": "General Escobedo",
    "Oaxaca": "Oaxaca City",
    "Oaxaca de Juárez": "Oaxaca City",
    "Río Grande": "Rio Grande",
    "San Andrés Huayápam": "San Andres Huayapam",
    "San José del Progreso": "San Jose del Progreso",
    "San Martín Tilcajete": "San Martin Tilcajete",
    "Santa Lucía": "Santa Lucia del Camino",
    "Santa Lucía Ocotlán": "Santa Lucia Ocotlan",
    "Santa María Atzompa": "Santa Maria Atzompa",
    "Santa María Coyotepec": "Santa Maria Coyotepec",
    "Santa María Jalapa del Marqués": "Santa Maria Jalapa del Marques",
    "Santiago Yolomécatl": "Santiago Yolomecatl",
    "Santiago Yosondúa": "Santiago Yosondua",
    "Tataltepec de Valdés": "Tataltepec de Valdes",
    "Tuxtepec": "San Juan Bautista Tuxtla",
    "Amozoc": "Amozoc de Mota",
    "Benito Juárez": "Benito Juarez",
    "Ciudad de Cuetzalan": "Cuetzalan",
    "Los Reyes de Juárez": "Los Reyes de Juarez",
    "Pahuatlán de Valle": "Pahuatlan de Valle",
    "Puebla": "Puebla City",
    "San Francisco": "Ixtacamaxtitlán",
    "San Francisco Ocotlán": "San Francisco Ocotlan",
    "Tecamachalco": "Xaltecacahuayo",
    "Teziutlan": "Teziutlán",
    "Xicotepec de Juárez": "Xicotepec de Juarez",
    "Santa Rosa Jauregui": "Santa Rosa Jáuregui",
    "Cozumel": "San Miguel de Cozumel",
    "Othón P. Blanco": "Othon P. Blanco",
    "San Luis Potosí": "San Luis Potosí City",
    "Soledad de Graciano Sánchez": "Soledad de Graciano Sanchez",
    "Ciudad Río Bravo": "Ciudad Rio Bravo",
    "Graciano Sánchez": "Graciano Sanchez",
    "Gustavo Díaz Ordaz": "Gustavo Diaz Ordaz",
    "San Simón Tlatlahuquitepec": "San Simon Tlatlahuquitepec",
    "Tlaxcala": "Tlaxcala City",
    "Ixhuatlán del Café": "Ixhuatlan del Cafe",
    "Ixhuatlán del Sureste": "Ixhuatlan del Sureste",
    "Las Vigas de Ramírez": "Las Vigas de Ramirez",
    "Martínez de la Torre": "Martinez de la Torre",
    "Poza Rica de Hidalgo": "Poza Rica",
    "Dzidzantun": "Dzidzantún",
    "Oxkutzkab": "Oxkutzcab",
    "Tecax": "Tekax",
    "Temozon": "Temozón",
    "Uman": "Umán",
    "General Pánfilo Natera": "General Panfilo Natera",
    "Nochistlán de Mejía": "Nochistlan de Mejia",
    "Teúl de González Ortega": "Teul de Gonzalez Ortega",
    "Zacatecas": "Zacatecas City",
    "Ijebu-Ode": "Ijebu Ode",
    "De Wijk": "de Wijk",
    "Vlissingen": "Flushing",
    "Å i Åfjord": "Å",
    "Waitakere": "Waitakere City",
    "Wanganui": "Whanganui",
    "Panamá": "Panama City",
    "Tingo María": "Tingo Maria",
    "Provincia de Nazca": "Nazca",
    "Lima": "Lima region",
    "Campoverde": "Campo Verde",
    "Tuguegarao": "Tuguegarao City",
    "Tacloban": "Tacloban City",
    "Davao": "Davao City",
    "Cotabato": "Cotabato City",
    "Baguio": "Baguio City",
    "Jhang": "Jhang Sadar",
    "Lala Musa": "Lalamusa",
    "Águeda": "Águeda Municipality",
    "Idanha-A-Nova": "Idanha-a-Nova",
    "Figueira da Foz": "Figueira da Foz Municipality",
    "Soure": "Soure Municipality",
    "Crato": "Crato Municipality",
    "Sines": "Sines Municipality",
    "La Paloma": "La Paloma del Espiritu Santo",
    "Ygatimi": "Villa Ygatimi",
    "Nanawua": "Nanawa",
    "San Pedro del Paraná": "San Pedro del Parana",
    "Juan de Ayolas": "Ayolas",
    "Santa Rosa Misiones": "Santa Rosa",
    "Bacău": "Bacau",
    "Botoşani": "Botosani",
    "Braşov": "Brasov",
    "Buzău": "Buzau",
    "Steierdorf": "Anina",
    "Iaşi": "Iasi",
    "Timişoara": "Timișoara",
    "Kaluga": "Kaluga Oblast",
    "Korolev": "Korolyov",
    "Orël": "Oryol",
    "Peterhof": "Petergof",
    "Kazan": "Kazan'",
    "Växjö": "Vaxjo",
    "Malmö": "Malmo",
    "Göteborg": "Gothenburg",
    "Liptovský Hrádok": "Liptovsky Hradok",
    "Kpalimé": "Palimé",
    "Sansanné-Mango": "Mango",
    "Thon buri": "Thon Buri",
    "Phra Pradaeng": "Amphoe Phra Pradaeng",
    "Samut Prakan": "Mueang Samut Prakan",
    "Buri Ram": "Buriram",
    "Sukhothai": "Sukhothai Thani",
    "Kuşadası": "Kusadasi",
    "Bozcaada": "Tenedos",
    "Elazığ": "Elâzığ",
    "Ereğli": "Heraclea",
    "Tokat": "Tokat Province",
    "Kaohsiung": "Kaohsiung City",
    "Nikopol": "Mykytyn Rog",
    "Piatykhatky": "Pyatykhatky",
    "Savran": "Savran'",
    "Lokhvytsia": "Lokhvytsya",
    "Kupjansk": "Kupiansk",
    "Lazurne": "Novooleksiyivka",
    "Kamianka": "Kamyanka",
    "Belvedere": "Belvedere Tiburon",
    "Big Bear City": "Big Bear",
    "Carmel-by-the-Sea": "Carmel",
    "Edwards Air Force Base": "Edwards",
    "Saint Helena": "St. Helena",
    "Sea Ranch": "The Sea Ranch",
    "Shasta Lake": "Lake Shasta",
    "Silver Lakes": "Helendale",
    "Hallandale Beach": "Hallandale",
    "Mount Dora": "Mt. Dora",
    "Lanai City": "Lanai",
    "Volcano": "Volcano Village",
    "Silver Hill": "Suitland-Silver Hill",
    "Mount Morris": "Mt. Morris",
    "Breckenridge": "Brandon",
    "St. Louis": "St Louis",
    "Southport": "Smithville",
    "New Castle": "Newcastle",
    "Hazlet Township": "Hazlet",
    "Vernon Valley": "Vernon",
    "New York City": "New York",
    "Mount Pleasant": "Mt. Pleasant",
    "West Columbia": "Columbia",
    "Heber City": "Heber",
    "Des Moines": "DesMoines",
    "McChord Air Force Base": "Joint Base Lewis McChord",
    "Otis Orchards-East Farms": "Otis Orchards",
    "Puntas de Valdéz": "Puntas de Valdez",
    "Andijon": "Andijan",
    "Urganch": "Urgench",
    "Puerto Píritu": "Puerto Piritu",
    "Colón": "San Juan de Colón",
    "Lạng Sơn": "Lạng Sơn Province",
    "Hội An": "Hoi An",
    "Tuy Hòa": "Tuy Hoa",
    "Sóc Trăng": "Sóc Trăng Province",
    "Bắc Giang": "Bắc Giang Province",
    "Nam Định": "Nam Định Province",
    "Thái Nguyên": "Thái Nguyên Province",
    "Cần Thơ": "Can Tho",
    "Port-Vila": "Port Vila",
    "Al Mukalla": "Mukalla",
    "Al Ghaydah": "Al Ghayḑah",
    "Graaff-Reinet": "Graaff Reinet"
}